import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import fileService from "./fileService";

interface FileState {
  loading: boolean;
  error: any | null;
  message: string | null;
}

const initialState: FileState = {
  loading: false,
  error: null,
  message: null,
};

export const openFile = createAsyncThunk(
  "file/openFile",
  async (url: string, { rejectWithValue }) => {
    try {
      const opened = await fileService.openFile(url); 
        return { success: opened };
    } catch (error: any) {
      return rejectWithValue(error.message || "Error al abrir archivo");
    }
  }
);


const fileSlice = createSlice({
  name: "file",
  initialState,
  reducers: {
    clearFileError: (state) => {
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(openFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(openFile.fulfilled, (state) => {
        state.loading = false;
        state.message = "Archivo abierto correctamente";
      })
      .addCase(openFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearFileError } = fileSlice.actions;
export default fileSlice.reducer;